import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PlatformUser } from '@/types/api.types'
import { platformService } from '@/services/platformService'

interface PlatformAuthState {
    platformUser: PlatformUser | null
    isAuthenticated: boolean
    isLoading: boolean
    login: (username: string, password: string, mfaCode?: string) => Promise<void>
    logout: () => Promise<void>
    initAuth: () => Promise<void>
}

export const usePlatformAuthStore = create<PlatformAuthState>()(
    persist(
        (set) => ({
            platformUser: null,
            isAuthenticated: false,
            isLoading: true,

            login: async (username, password, mfaCode) => {
                const user = await platformService.login(username, password, mfaCode)
                set({ platformUser: user, isAuthenticated: true, isLoading: false })
            },

            logout: async () => {
                await platformService.logout()
                set({ platformUser: null, isAuthenticated: false })
            },

            initAuth: async () => {
                try {
                    if (platformService.isAuthenticated()) {
                        const user = await platformService.me()
                        set({ platformUser: user, isAuthenticated: true, isLoading: false })
                    } else {
                        set({ platformUser: null, isAuthenticated: false, isLoading: false })
                    }
                } catch {
                    set({ platformUser: null, isAuthenticated: false, isLoading: false })
                }
            },
        }),
        {
            name: 'platform-auth-storage',
            partialize: (s) => ({ platformUser: s.platformUser, isAuthenticated: s.isAuthenticated }),
        }
    )
)

export const usePlatformAuth = () => usePlatformAuthStore()
